import React from 'react';
import { Redirect } from 'react-router-dom';
import appRoutes from '../../../../app-routes';

const HomePage = () => {
  return <Redirect to={appRoutes.REPORT_STATISTICS} />;
};

export default HomePage;
